<script>
import { mapActions } from 'vuex'
import h337 from 'heatmap.js'
export default {
  props: {
    playerId: {
      type: Number,
      default: () => null,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      heatmapHours: [],
      heatmapDays: [],
      data: [],
      config: {
        container: null,
        radius: 2,
        maxOpacity: 0.8,
        minOpacity: 0,
        blur: 0,
      },
      legendMin: 0,
      legendMax: 0,
      legendCanvasElement: null,
    }
  },
  computed: {
    computedChartWidth() {
      return this.chartWidth
    },
  },
  async created() {
    this.getPlayerPositionData({ id: this.playerId })
      .then((response) => {
        const width = +window
          .getComputedStyle(this.$refs.chart)
          .width.replace(/px/, '')

        const height = +window
          .getComputedStyle(this.$refs.chart)
          .height.replace(/px/, '')

        response.forEach((item) => {
          var x = item[1] * (width / 160)
          var y = item[0] * (height / 95)
          this.data.push({ x: x, y: y, value: item[2] })
        })
        this.initMap()

        this.loaded = true
        this.$emit('loaded', true)
      })
      .catch((error) => {
        console.error('Chart-Heatmap Player Compare Data fetch failed', error)
      })
  },
  mounted() {},
  methods: {
    ...mapActions('players', ['getPlayerPositionData']),
    initMap() {
      this.config.container = this.$refs.chart

      const map = h337.create({
        ...this.config,
      })

      map.setData({
        max: 110,
        min: 0,
        data: this.data,
      })
    },
  },
}
</script>

<template>
  <v-responsive
    v-if="playerId !== null && playerId"
    aspect-ratio="4/3"
    :class="$style.responsive"
    :content-class="$style.responsiveContent"
  >
    <div :class="$style.soccerField">
      <img
        ref="chartBackground"
        :class="$style.soccerFieldImage"
        src="@assets/images/football_field.svg"
      />
      <div
        id="heatmapContainer"
        ref="chart"
        :class="$style.chart"
        :style="'width:' + computedChartWidth + 'px;'"
      ></div>
    </div>
  </v-responsive>
</template>

<style lang="scss" module>
@import '@design';

.responsive {
  height: 100%;
}

.responsiveContent {
  display: flex;
  align-items: center;
}

.soccerField {
  position: relative;
  width: 280px;
  height: 200px;
  margin: 0 auto;
}

.soccerFieldImage {
  position: absolute;
  top: -53px;
  left: 57px;
  width: 165px;
  height: 276px;
  opacity: 0.8;
  transform: rotate(90deg);
}

.chart {
  top: 10px;
  left: 10px;
  width: 260px;
  height: 150px;
  opacity: 0.9;

  canvas {
    width: 100%;
    height: 100%;
  }
}

.legend {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 10px;
  background: white;
}

#min {
  float: left;
}

#max {
  float: right;
}
</style>
